const HEX_CHARACTER_SET = '0123456789abcdef';
function generateHexString(size) {
  let generatedString = '';
  for (let i = 0; i < size; i++) {
    let randomCharacterLocation = Math.floor(Math.random() * Math.floor(HEX_CHARACTER_SET.length));
    generatedString += HEX_CHARACTER_SET[randomCharacterLocation];
  }
  return generatedString;
}
export function generateHeadingId() {
  return `h_${generateHexString(10)}`;
}